import { User } from "../api/graphql";

type ModelUser = Pick<User, "name"> | null;

const modelUserName = (modelUser: ModelUser) => {
  return modelUser ? modelUser.name : "System";
};

export default modelUserName;
